import CampanhaService from './CampanhaService'
export default class InternacionalizacaoService {
    
    messages = {}

    load = () => {
        let campanhaService = new CampanhaService()
        this.init(campanhaService.campanhaCorrente())
    }

    diasSemana = () => {
        return [
            this.message("geral.diasemana.1", "DOM"),
            this.message("geral.diasemana.2", "SEG"),
            this.message("geral.diasemana.3", "TER"),
            this.message("geral.diasemana.4", "QUA"),
            this.message("geral.diasemana.5", "QUI"),
            this.message("geral.diasemana.6", "SEX"),
            this.message("geral.diasemana.7", "SAB")
        ];
    }

    meses = () => {
        return [
            this.message("geral.mes.1", "JANEIRO"),
            this.message("geral.mes.2", "FEVEREIRO"),
            this.message("geral.mes.3", "MARÇO"),
            this.message("geral.mes.4", "ABRIL"),
            this.message("geral.mes.5", "MAIO"),
            this.message("geral.mes.6", "JUNHO"),
            this.message("geral.mes.7", "JULHO"),
            this.message("geral.mes.8", "AGOSTO"),
            this.message("geral.mes.9", "SETEMBRO"),
            this.message("geral.mes.10", "OUTUBRO"),
            this.message("geral.mes.11", "NOVEMBRO"),
            this.message("geral.mes.12", "DEZEMBRO"),
        ]
    }

    init = (campanha) => {



        let mensagens = {}
        if (campanha && campanha.messages) {
            
            campanha.messages.forEach((item) => {
                let idioma = mensagens["idioma"]; // temporário: futuramente mudamos para buscar por idioma
                if (! idioma) {
                    idioma = {};
                    mensagens["idioma"] = idioma;
                } 
                idioma[item.code] = item.message;
            });
        }
        this.messages = mensagens;
    }

    message = (code, padrao) => {
        if (this.messages && this.messages["idioma"] && this.messages["idioma"][code]) {
            return this.messages["idioma"][code]
        }

        return padrao ? padrao : undefined
    }

}